import PersonRangeSelector from './src/main';

/* istanbul ignore next */
PersonRangeSelector.install = function(Vue) {
  Vue.component(PersonRangeSelector.name, PersonRangeSelector);
};

export default PersonRangeSelector;
